import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiUsers,
  FiGlobe,
  FiSettings,
  FiChevronDown,
  FiChevronRight,
  FiMenu,
  FiX,
  FiUserPlus,
  FiUser,
  FiDollarSign,

} from 'react-icons/fi';
import { FaCar, FaCarSide } from "react-icons/fa";

import './Sidebar.css';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { name: 'Dashboard', icon: <FiHome />, path: '/', submenu: [] },
    { name: 'Client', icon: <FiHome />, path: 'ViewCompany', submenu: [] },

    {
      name: 'Utility',
      icon: <FiSettings />,
      path: null,
      submenu: [
        { name: 'District', path: '/ViewDistrict', icon: <FiGlobe /> },
        { name: 'Department', path: '/Departments', icon: <FiGlobe /> },
        { name: 'Branch', path: '/ViewBranch', icon: <FiGlobe /> },
        { name: 'HouseType', path: '/ViewHouseType', icon: <FiGlobe /> },
        { name: 'Zone', path: '/ViewZone', icon: <FiGlobe /> },
        { name: 'Role', path: '/ViewRole', icon: <FiUser /> },     
       
       
      ]
    },
    {
      name: 'Car',
      icon: <FaCarSide />,
      path: null,
      submenu: [
        
        { name: 'Car', path: '/ViewCar', icon: <FaCarSide /> },

       
      ]
    },
    {
      name: 'Collector',
      icon: <FiUsers />,
      path: null,
      submenu: [{ name: 'Collector', path: '/ViewCollector', icon: <FiUsers /> }]
    },
    {
      name: 'Customers',
      icon: <FiUsers />,
      path: null,
      submenu: [
        { name: 'Customers', path: '/Customers', icon: <FiUsers /> },
        // { name: 'Member Registration', path: '/Members', icon: <FiUsers /> }
      ],
     
    },
    {
      name: 'Collections',
      icon: <FiUsers />,
      path: null,
      submenu: [{ name: 'Collections', path: '/Collections', icon: <FiUsers /> },
      { name: 'Carmonitors', path: '/Carmonitors', icon: <FiUsers /> },]
    },
    {
      name: 'Finance',
      icon: <FiUsers />,
      path: null,
      submenu: [{ name: 'Customer Payments', path: '/CustomerPaidments', icon: <FiDollarSign /> }]
    },
    // {
    //   name: 'Finance',
    //   icon: <FiDollarSign />,
    //   path: null,
    //   submenu: [
           
    //     { name: 'Member Payments', path: '/Payments', icon: <FiDollarSign /> },
    //   ],
    // },
    
    { name: 'Settings', icon: <FiSettings />, path: '/settings', submenu: [] }
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setSidebarOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSubmenu = (name) => setActiveSubmenu(activeSubmenu === name ? null : name);
  const toggleSidebar = () => isMobile ? setSidebarOpen(!sidebarOpen) : setIsCollapsed(!isCollapsed);
  const closeSidebarOnMobile = () => { if (isMobile) setSidebarOpen(false); };

  return (
    <>
      <button
        className={`mobile-menu-button ${sidebarOpen ? 'hidden' : ''}`}
        onClick={toggleSidebar}
      >
        <FiMenu size={24} />
      </button>

      {sidebarOpen && isMobile && (
        <div className="sidebar-overlay" onClick={closeSidebarOnMobile} />
      )}

      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobile ? 'mobile' : ''} ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {/* {(!isCollapsed || isMobile) && <h2>HALDOOR</h2>} */}
          {(!isCollapsed || isMobile) && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
            <img
              src="/logo.png"
              alt="Deegan Wadaag"
              style={{ height: '150px', width: '150px' }}
            />
          </div>
          
          )}

          <button className="toggle-btn" onClick={toggleSidebar}>
            {isMobile ? <FiX /> : (isCollapsed ? <FiMenu /> : <FiX />)}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.name}>
                {item.submenu.length > 0 ? (
                  <>
                    <div className="menu-item" onClick={() => toggleSubmenu(item.name)}>
                      <span className="icon">{item.icon}</span>
                      {(!isCollapsed || isMobile) && (
                        <>
                          <span>{item.name}</span>
                          <span className="arrow">
                            {activeSubmenu === item.name ? <FiChevronDown /> : <FiChevronRight />}
                          </span>
                        </>
                      )}
                    </div>
                    {(!isCollapsed || isMobile) && (
                      <ul className={`submenu ${activeSubmenu === item.name ? 'open' : ''}`}>
                        {item.submenu.map((subItem) => (
                          <li key={subItem.name}>
                            <NavLink
                              to={subItem.path}
                              className={({ isActive }) => isActive ? 'active' : ''}
                              onClick={closeSidebarOnMobile}
                            >
                              {subItem.icon && <span className="submenu-icon">{subItem.icon}</span>}
                              <span>{subItem.name}</span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
                    onClick={closeSidebarOnMobile}
                  >
                    <span className="icon">{item.icon}</span>
                    {(!isCollapsed || isMobile) && <span>{item.name}</span>}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
